import { Text } from '@/components/shared/Text/Text';
import { TextField } from '@/components/shared/TextField/TextField';

const CoachNote = ({
  coachNote,
  setCoachNote,
}: {
  coachNote: string;
  setCoachNote: (note: string) => void;
}) => {
  return (
    <>
      <Text.Regular className="mb-2" weight="bold">
        Coach comments:
      </Text.Regular>

      <TextField
        placeholder="Coach note"
        isTextArea
        rows={5}
        className="p-0"
        value={coachNote}
        onChange={(v) => setCoachNote(v.target.value)}
      />
    </>
  );
};

export default CoachNote;
